module.exports = __webpack_public_path__ + "img/bothsides_300.93be0c1a.png";